<template>
    <div class="layout-contrast-create-pop">
        <div class="contrast-create-pop-title">请选择对比类型</div>
        <div class="contrast-create-pop-list">
            <div class="contrast-create-pop-item" v-bind:class="{'cur': itemIndex == curIndex}" v-for="(itemData, itemIndex) in itemList" v-bind:key="itemData.type" @click="clickContrastTypeItem(itemData)">{{itemData.text}}</div>
        </div>
        <div class="contrast-create-pop-btn-box dsp-flex">
            <div class="contrast-create-pop-btn btn-cancel" @click="clickCancel">取消</div>
            <div class="contrast-create-pop-btn btn-confirm" @click="clickConfirm">确定</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VantContrastCreatePop',
    components: {  },
    computed: {
        
    },
    data() {
        return {
            itemList: [
                {text:'对比学习', index: 0, type: 1},
                {text:'对比合作', index: 1, type: 2},
                {text:'对比合婚', index: 2, type: 3},
                {text:'对比六亲', index: 3, type: 4},
            ],
            curIndex: 2,
        }
    },
    mounted() {
        this.$bus.on('resetContrastStatus', this.resetContrastStatus);
    },
    destroyed() {
        this.$bus.off('resetContrastStatus', this.resetContrastStatus);
    },
    methods: {
        resetContrastStatus() {
            this.curIndex = 2;
        },
        clickContrastTypeItem(iData) {
            this.curIndex = iData.index;
            this.$store.state.contrast.contrastChoosedType = iData.type;
            this.$store.state.contrast.contrastChoosedTypeText = iData.text;
        },
        clickCancel() {
            this.$store.state.contrast.showContrastCreatePanel = false;
        },
        clickConfirm() {
            this.$store.state.contrast.showContrastCreatePanel = false;
            // 跳转到二级页面
            let curPath = this.$router.history.current.path;
            let chooseFromPage = curPath.indexOf('contrastlist') >= 0 ? 'contrastlist' : curPath.indexOf('search/result') >= 0 ? 'search_result' : curPath.indexOf('search/advanced') >= 0 ? 'search_advanced' : curPath.indexOf('detail') >= 0 ? 'detail' : '';
            switch(chooseFromPage) {
                case 'contrastlist':
                    this.$store.dispatch('allrecord/resetRecordData');
                    this.$store.state.chooserecord.chooseFromPage = chooseFromPage;
                    this.$store.state.chooserecord.chooseRecordType = 'multiple';
                    setTimeout(() => {
                        this.$router.replace(curPath+'/chooserecord');
                    }, 20);
                    break;
                case 'search_result':
                case 'search_advanced':
                    let selectedList = this.$store.state.search.searchResultSelectedList;
                    let contrastList = this.$store.state.record.recordTotalData.filter(el => selectedList.indexOf(el.id) >= 0);
                    this.$store.dispatch('contrast/addContrast', {
                        choosedList: contrastList,
                        cb: (cData)=> {
                            this.$router.replace('/contrast/'+chooseFromPage+'/'+cData.id)
                        }
                    });
                    break;
                case 'detail':
                    let detailInfo = this.$store.state.detail.personInfo;
                    console.error('createContrast   detail', detailInfo)
                    setTimeout(() => {
                        this.$store.dispatch('chooserecord/initChoosedMultipleItemList', {
                            bzArr: [detailInfo.id]
                        });
                        this.$store.state.chooserecord.chooseFromPage = 'detail';
                        this.$store.state.chooserecord.chooseRecordType = 'multiple';
                        this.$router.replace(curPath+'/chooserecord');
                    }, 100);
                    break;
                default:
                    break;
            }
        }
    }
}
</script>
